import {LeadPageDisplay} from "@/components/leadPages"
import AppHead from "@/components/AppHead"
import {DEFAULT_PIC} from "../../leadPages/[pageId]"
import type {GetServerSidePropsContext} from "next"
import {getServices} from "@/lib/server/index"
import {getS3Urls} from "@/lib/server/urlSigning"
import type {LeadpageInit} from "@/lib/server/trpcRouters/leadpages"
import {LeadPageType} from "@/lib/server/models/leadPage"

const ERROR_REDIRECT = {location: "/404"} as const
const TMP_REDIRECT = 302

type LeadPageExternalViewProps = {
    page: LeadpageInit & { 
        type: LeadPageType | string & {}
    }
    title: string
    pageId: string
    onehomesDomain?: string | null
}

type ServerProps = {
    props: LeadPageExternalViewProps | {}
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<ServerProps> {
    const {query, res} = ctx
    try {
        console.log("hit")
        const {pageCode} = query 
        if (!pageCode || typeof pageCode !== "string") {
            res.writeHead(TMP_REDIRECT, ERROR_REDIRECT)
            return {props: {}}
        }
        const services = await getServices()
        const {LeadPage} = services
        const pageQuery = await LeadPage
            .findOne({_id: pageCode})
            .exec()
        if (!pageQuery) {
            res.writeHead(TMP_REDIRECT, ERROR_REDIRECT)
            return {props: {}}
        }
        // getServerSideProps is not intelligent enough to
        // serialize the mongo object. Must do it manually
        const page = JSON.parse(JSON.stringify(pageQuery)) as typeof pageQuery
        const website = await services.WebLeadMagent.findOne({
            userRef: pageQuery.userRef
        }).exec()
        const onehomesDomain = website?.uniqueName || null 
        if (page.pictureUrl === DEFAULT_PIC) {
            return {props: {
                page,
                title: `${page.firstName} ${page.lastName} | ${page.professionalTitle}`,
                pageId: pageCode,
                onehomesDomain
            }}
        }
        const [signedUrl] = await getS3Urls({
            s3Images: [{keyName: page.pictureUrl}],
        })
        if (!signedUrl) {
            console.warn("picture url was not signed successfully (returned null)")
            page.pictureUrl = DEFAULT_PIC
        } else {
            page.pictureUrl = signedUrl
        }
        const props: LeadPageExternalViewProps = {
            page,
            title: `${page.firstName} ${page.lastName} | ${page.professionalTitle}`,
            pageId: pageCode,
            onehomesDomain 
        }
        return {props}
    } catch (err) {
        console.error(err)
        res.writeHead(TMP_REDIRECT, ERROR_REDIRECT)
        return {props: {}}
    }
}

export default function LeadPageExternalView(
    props: LeadPageExternalViewProps
): JSX.Element {
    const domain = props.onehomesDomain
    const onehomeLink = domain 
        ? `${typeof window !== "undefined" ? location.protocol : ""}//${domain}.${process.env.NEXT_PUBLIC_ONEHOME_ORIGIN}`
        : null
    console.log('link', onehomeLink)
    return <>
        <AppHead title={props.title} enableCrispChat={false}/>
        <main>
            <div className="w-screen h-screen overflow-x-hidden overflow-y-scroll bg-gray-100">
                <LeadPageDisplay 
                    {...props.page} 
                    pageId={props.pageId}
                    onehomesLink={onehomeLink}
                />
            </div>
        </main>
    </>
}